import { useFormikContext } from 'formik'
import { Button, Grid, IconButton, Paper, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'

import { TextInput } from '../text-input'
import { IAIGenerateFormValues } from 'src/types'

import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

interface IGenerateFormProps {
  handleAddition: (value: string) => void
  handleClose: () => void
  textPrompt?: string
}

const GenerateForm = ({ handleAddition, handleClose, textPrompt }: IGenerateFormProps) => {
  const [t] = useTranslation()
  const { values, handleChange, isSubmitting, errors, isValid, setFieldValue } =
    useFormikContext<IAIGenerateFormValues>()

  const classes = useStyles()

  const handleAdditionClick = () => {
    if (errors.generatedDescription) return
    handleAddition(values.generatedDescription)
  }

  const handlePrepopulateClick = () => {
    setFieldValue('description', textPrompt)
  }

  return (
    <Paper className={classes.paperWrapper}>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
      <Typography className={classes.title}>
        <HelperWrapper t="ai-generation-form-title" />
      </Typography>
      <Grid className={classes.formWrapper}>
        <Grid className={classes.inputSection}>
          <Typography className={classes.inputTitle}>
            <HelperWrapper t="ai-generation-form-subtitle" />
          </Typography>
          {textPrompt && (
            <Button variant="text" onClick={handlePrepopulateClick}>
              <HelperWrapper t="ai-generation-form-example-prompt" />
            </Button>
          )}
          <TextInput
            error={errors.description}
            inputName="description"
            value={values.description}
            handleChange={handleChange}
            multiline
            disabled={isSubmitting}
            inputUpperLabel={t('ai-generation-form-description-label.v')}
            rows={3}
          />
        </Grid>
        <Grid className={classes.buttonWrapper}>
          <Button
            className={classes.modalButton}
            variant="contained"
            size="large"
            type="submit"
            disabled={!isValid || isSubmitting}
          >
            <HelperWrapper t="generate-button-text" />
          </Button>
        </Grid>
        <Grid className={classes.inputSection}>
          <div className={classes.generationWrapper}>
            <Typography className={classes.inputTitle}>
              <HelperWrapper t="ai-generation-form-resp" />
            </Typography>
            <div>
              <Button
                className={classes.modalButton}
                variant="contained"
                size="large"
                type="button"
                onClick={handleAdditionClick}
                disabled={
                  !!errors.generatedDescription || isSubmitting || !values.generatedDescription
                }
              >
                <HelperWrapper t="ai-generation-form-submit" />
              </Button>
            </div>
          </div>
          <TextInput
            error={errors.generatedDescription}
            inputName="generatedDescription"
            value={values.generatedDescription}
            handleChange={handleChange}
            multiline
            disabled={isSubmitting}
            inputUpperLabel={t('ai-generation-form-generated-description-label.v')}
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

export { GenerateForm }
